import { useState } from "react";
import { FileText } from "lucide-react";
import { todayJkt } from "@/lib/api";
import ReportView from "@/components/ReportView";
import { monthRange } from "@/pages/UangKas";

export default function LaporanBulanan() {
  const [month, setMonth] = useState(todayJkt().slice(0, 7));
  const picker = <input type="month" className="jt-input w-44" value={month} onChange={(e) => e.target.value && setMonth(e.target.value)} aria-label="Pilih bulan" data-testid="month-input" />;
  return <ReportView title="Laporan Bulanan" subtitle="Ringkasan lengkap uang, kasbon, dan stok selama satu bulan." icon={FileText} range={monthRange(month)} picker={picker} showTransactions />;
}
